import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { nestedRoutePath, routes } from '../../../constants/routes'

import AdminAccountView from './view'
import AdminAccountsList from './list'
import AdminAccountCreate from './create'
import AdminUsersIndex from './users/index'
import AdminImeiIndex from './imeis/index'
import AdminAccountDashboard from './dashboard'


const AdminAccountsIndex = () => {
    return (
        <>
            <div className="builder-view">
                <Routes>
                    <Route path={nestedRoutePath(routes.adminAccountsIndex.path, routes.adminUsersIndex.path, true)} element={<AdminUsersIndex />} />
                    <Route path={nestedRoutePath(routes.adminAccountsIndex.path, routes.adminImeiIndex.path, true)} element={<AdminImeiIndex />} />
                    <Route path={nestedRoutePath(routes.adminAccountsIndex.path, routes.adminAccountView.path)} element={<AdminAccountView />} />
                    <Route path={nestedRoutePath(routes.adminAccountsIndex.path, routes.adminAccountCreate.path)} element={<AdminAccountCreate />} />
                    <Route path={nestedRoutePath(routes.adminAccountsIndex.path, routes.adminAccountDashboard.path)} element={<AdminAccountDashboard />} />
                    <Route index element={<AdminAccountsList />} />
                </Routes>
            </div>
        </>
    )
}

export default AdminAccountsIndex
